/**
 * Route copy for `src/routes/advisor` (keys: `routes.advisor.<file>.<key>`).
 *
 * `fr` is the source; `en` and `ar` are typed against it, so a missing or extra
 * key fails `tsc` (and parity.test.ts). Keys are referenced from the route files
 * through `t()` / `tr()` — edit values freely, never rename a key without its call site.
 *
 * Locale file: en (typed against ./fr). One file per locale so
 * every non-default locale is a separate, lazily-loaded chunk.
 */

import type { Catalog } from './fr';

const en: Catalog = {
  recommendationsPage: {
    recommendations: '💡 Recommendations',
    theAiSBestRecommendationsFor: 'The AI\'s best recommendations for your content, ads and prospecting — analyzed from your data, applicable in one click.',
    analyzing: 'Analyzing…',
    refresh: 'Refresh',
    analyzingYourData: 'Analyzing your data…',
    theAiAdvisorWillBeAvailable: 'The AI advisor will be available soon. Your recommendations will appear here as soon as it is enabled.',
    couldNotLoadTheRecommendationsMessage: 'Could not load the recommendations: {{message}}',
    recommendation: 'recommendation',
    importantImportant: ' · {{important}} important',
    filterByArea: 'Filter by area',
    noRecommendationForNowPublishContent: 'No recommendation for now. Publish content, launch a campaign or a prospecting run: the AI will analyze your results and suggest improvements.',
    all: 'All',
  },
};

export default en;
